import React, {useState,useEffect} from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { BorderBottom,  TitleSection, Wrapp, WrappProjects } from '../../globalStyle';
import LeftArrow from '../left-arrow/arrow';
import ImageError from '../error/error';
import { url } from '../../App';
import Skeleton from '../skeleton/skeleton';

const Box = styled(Link)`
    width:300px;
    height:170px;
    border-radius:4px;
    border:1px solid rgba(0,0,0,0.1);
    box-shadow: 0 2px 2px 1px rgba(0,0,0,0.1);
    margin-bottom:60px;
    display:flex;
    text-decoration: none;
    transition: .5s ease;
    position:relative;
    flex-direction:column;
    &:hover{
        transform: scale(1.1);
    }
@media screen and (max-width: 1100px){
    margin-bottom:20px;
}
`
const WrappImage = styled.div`
    width:100%;
    height:240px;
    overflow:hidden;
`

const ImgProject = styled.img`
    width: 100%;
    object-fit:contain;
    border-radius: 4px 4px 0 0 ;
`
const WrappJudul = styled.div`
    display:flex;
    justify-content: center;
    align-items:center;
    padding-right:10px;
    padding-left:10px;
`
const TitleProject = styled(Link)`
    font-size:14px;
    color:#000;
    &:hover{
        text-decoration:none;
    }
`
const JudulProject = styled.h4`
    font-size:14px;
    color:#000;
    z-index:99;
    margin-top:-40px;
`

function ProjectsAll(){
    const [ data, setData ] = useState([]);
    const [loading, setLoading] = useState(false)
    const [error,setError] = useState(false)

    useEffect(() => {

    async function getAllProject(){
        setLoading(true)
        try{
            let res = await fetch(`${url}/project`)
            let data = await res.json()
            setData(data.data)
        }catch(error){
            setError(true)
        }finally{
            setLoading(false)
        }
    }
      getAllProject()
      return()=>{
          setData('')
      }
    },[])
    
   if(error){
       return(
           <ImageError />
       )
   }
// 
        return(
            <>
            <Wrapp margin="10px">
            <TitleSection>All-Projects</TitleSection>
            <BorderBottom />
            <WrappProjects>
                {
                    loading ? (<Skeleton width={"300px"} height={"280px"} amount={3} />) : (
                        data.map(item => (
                            <Box key={item.id} to={'projects/'+item.id}>
                                <WrappImage>
                                    <ImgProject src={item.image}  alt="Website" />
                                </WrappImage>
                                <WrappJudul> 
                                    <JudulProject>{item.nama.substr(0,40) + '...'}</JudulProject>
                                    {/* <TitleProject to={'projects/' + item.id}>{item.id}</TitleProject> */}
                                </WrappJudul>
                            </Box>
                            )
                        )
                    )
                }
            </WrappProjects>
            </Wrapp>
           </>
        )
}
export default ProjectsAll